import React from 'react';
import moment from 'moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { BaseFilterComponentProps } from './types';

export const DateFilter = <TableEntity,>({
  filter,
  onChange,
}: BaseFilterComponentProps<TableEntity, moment.Moment | undefined>) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        slotProps={{
          textField: {
            size: 'small',
            sx: {
              height: 28.5,
              '& .MuiInputBase-root': {
                height: 28.5,
              },
              '& .MuiInputBase-input': {
                padding: '6px 8px',
                height: '20px',
                boxSizing: 'border-box',
              },
            },
          },
          openPickerIcon: {
            fontSize: '1rem',
          },
          openPickerButton: {
            size: 'small',
            sx: {
              padding: 0,
            },
          },
        }}
        value={filter ? moment(filter?.value) : null}
        onChange={date => onChange(date ? date : undefined)}
      />
    </LocalizationProvider>
  );
};
